import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "column is-narrow" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "add", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "has-text-danger is-tp-input-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      class: "columns is-vcentered",
      onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input input-domain",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.domain) = $event)),
          placeholder: "teleperformance.com"
        }, null, 512), [
          [_vModelText, _ctx.domain]
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: _normalizeClass(["button is-link is-outlined form-buttons mx-3", _ctx.loading ? 'is-loading' : ''])
        }, _hoisted_4, 2)
      ])
    ], 32),
    (_ctx.errors)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.errors), 1))
      : _createCommentVNode("", true)
  ], 64))
}